import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateC: SceneTemplate = {
    name: "תבנית ג",
    branding: {
        background: "secondary",
        foreground: {
            color: "primary",
            size: {
                width: 67,
                height: 100,
            },
            location: {
                x: 0,
                y: 0,
            },
        },
    },
    aspectRatio: "16:9",
    avatar: {
        size: {
            width: 33,
            height: 73,
        },
        location: {
            x: 67,
            y: 27,
        },
    },
    scene: {
        scale: 60,
        rounded: true,
        location: {
            x: 3.5,
            y: 20,
        },
    },
};
